import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const createMeetup = createAsyncThunk("createMeetup", async (meetupData, { rejectWithValue }) => {
  try {
    const response = await axiosHttp.post("meetup", meetupData);
    return response.data;
  } catch (err) {
    if (!err.response) throw err;
    return rejectWithValue(err.response.data);
  }
});

const MeetupCreateSlice = createSlice({
  name: "MeetupCreateSlice",
  initialState: {
    isLoading: false,
    success: false,
    data: null,
    error: null,
  },
  reducers: {
    resetCreateMeetup: (state) => {
      state.isLoading = false;
      state.success = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createMeetup.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createMeetup.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload?.data;
      })
      .addCase(createMeetup.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetCreateMeetup } = MeetupCreateSlice.actions;
export default MeetupCreateSlice.reducer;
